import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  categoryAdminFetchContactsSuccess,
  categoryAdminShowContactMessage,
  submitNewCategoryAdminResponse,
  submitEditCategoryDetailsResponse,
  selectedCategoryDeleteResposne,
  toggleCategoryModal,
  setCategoryList,
  changeAdminLoader,
  changeEditCategoryState,
  categoryFailResponse
} from "../actions";
import {
  CATEGORY_SUPER_ADMIN_FETCH_ALL_CONTACT,
  SUBMIT_NEW_CATEGORY_SUPER_ADMIN,
  SELECTED_CATEGORY_DELETE_SUPER_ADMIN,
  DELETE_CATEGORY_SUPER_ADMIN
} from "../constants/ActionTypes";
import axios from "../services/customer";

function* fetchCategoryRequest() {
  try {
    const response = yield axios.get("/servicecategories");
    yield put(categoryAdminFetchContactsSuccess(response.data));
  } catch (error) {
    yield put(categoryAdminShowContactMessage(error.response.data.message));
  }
}

function* submitNewCategory({payload}) {
    const {formValues,bussinesTypeId} = payload;
    console.log("CATEGORYSIPER",bussinesTypeId);
    
    if(formValues.editCategoryState) {
      const response = yield axios.put(`/servicecategories/${formValues._id}`,{
        name: formValues.name,
        parent_category:bussinesTypeId
      });
      yield put(submitEditCategoryDetailsResponse(response.data));
    } else {
      const response = yield axios.post(`/servicecategories`,{
        name: formValues.name,
        parent_category:bussinesTypeId
      });
      yield put(submitNewCategoryAdminResponse(response.data));
    }

}

function* deleteServices({ payload }) {
  try {
    //
    const { categoryList } = payload;
		console.log("TCL: function*deleteServices -> payload", payload)
    const deleteServicesSelected = categoryList.filter(item => item.selected);
    const deleteServicesIds = deleteServicesSelected.map(item => item._id);
    const deletedRequestApis = deleteServicesIds.map(id =>
      axios.delete(`servicecategories/${id}`)
    );
    console.log("TCL: function*deleteServices -> deletedRequestApis", deletedRequestApis)
    const response = yield Promise.all(deletedRequestApis);
    const deleteServices = [];
    const dontDeleteServices = [];
    response.forEach(element => {
      if (element.data.message === "active_appointment_found_for_deleted_service") {
        dontDeleteServices.push(element.data._id);
      } else {
        deleteServices.push(element.data._id);
      }
    });

    // if (dontDeleteServices.length === 0) {
			yield put(selectedCategoryDeleteResposne({ deleteServices }));
    // } else {
    //   yield put(haveAppointmentDeleteServices({ dontDeleteServices, deleteServices }));
    // }
  } catch (error) {
    yield put(categoryFailResponse(error.response.data.message));
	}
}

export default function* rootSaga() {
  yield all([
    takeEvery(CATEGORY_SUPER_ADMIN_FETCH_ALL_CONTACT, fetchCategoryRequest),
    takeEvery(SUBMIT_NEW_CATEGORY_SUPER_ADMIN, submitNewCategory),
    takeEvery(DELETE_CATEGORY_SUPER_ADMIN, deleteServices),
    // takeEvery(SELECTED_CATEGORY_DELETE_SUPER_ADMIN, fetchCategoryDelete),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/CategorySuperAdminSaga.js